import { Flex, IconButton, Input } from "@chakra-ui/react";
import { useState } from "react";
import { useIntl } from "react-intl";

import { AddIcon } from "@nens/ranalib";

import { RanaTags } from "../../../components/ranatags";

type ModelSchematisationTagsEditorProps = {
  editing: boolean;
  tags: string[];
  setTags: (tags: string[] | ((prevTags: string[]) => string[])) => void;
};

export function ModelSchematisationTagsEditor({
  editing,
  tags,
  setTags,
}: ModelSchematisationTagsEditorProps) {
  const intl = useIntl();
  const [newTag, setNewTag] = useState("");

  const addTag = () => {
    const trimmedTag = newTag.trim();
    if (!trimmedTag) return;

    setTags((current) => (current.includes(trimmedTag) ? current : [...current, trimmedTag]));
    setNewTag("");
  };

  const removeTag = (tagToRemove: string) => {
    setTags((current) => current.filter((tag) => tag !== tagToRemove));
  };

  return (
    <Flex maxW="full" flexDir="row" gap={4} alignItems="center" flexWrap="nowrap" minW={0}>
      {tags.length > 0 ? (
        <RanaTags layout="wrap" tags={tags} onRemove={editing ? removeTag : undefined} />
      ) : (
        "-"
      )}

      {editing && (
        <Flex minW={44} gap={2}>
          <Input
            placeholder={intl.formatMessage({ id: "file.add_tag", defaultMessage: "Add tag" })}
            size="sm"
            w="full"
            value={newTag}
            onChange={(event) => setNewTag(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                addTag();
              }
            }}
          />
          <IconButton
            isDisabled={!newTag.trim() || tags.includes(newTag.trim())}
            aria-label={intl.formatMessage({ id: "file.add_tag", defaultMessage: "Add tag" })}
            icon={<AddIcon boxSize={4} />}
            size="sm"
            variant="fourthiary"
            onClick={addTag}
            h="small_button"
            minH="small_button"
            minW="small_button"
            p={0}
          />
        </Flex>
      )}
    </Flex>
  );
}
